export default __webpack_public_path__ + "static/media/par_fin.5c43926e.png";